import React from 'react'
import $ from 'jquery'
import { addShake } from '../utility/helper'
import { localsMessages } from '../utility/getTemplateData'

let messages = localsMessages('common/amount')
let inputResize = function() {

	let donationVal = $('[name=donationAmount]')
	let	val = donationVal.val().replace(/[^0-9]/g, '')
	let	amountLen = val.length
	let	amountWidth = amountLen * 30 + 20

	let parsedVal = parseFloat(val) || 0
	let parsedValLen = parsedVal.toString().length

	if (parsedValLen <= 3) {
		amountWidth = '110'
	} else if ((parsedValLen === 4)) {
		amountWidth = '136'
	}

	donationVal.css({ width: amountWidth });
}

export default React.createClass({
	propTypes: {
		name: React.PropTypes.string,
		label: React.PropTypes.string,
		value: React.PropTypes.string,
		amount: React.PropTypes.string,
		symbol: React.PropTypes.string,
		code: React.PropTypes.string,
		decimalPoint: React.PropTypes.string,
		isEditable: React.PropTypes.bool,
		handleAmount: React.PropTypes.func
	},

	getInitialState() {
		return {
			amount: this.props.amount,
			symbol: this.props.symbol,
			code: this.props.code
		};
	},

	componentDidMount() {

		let isEditable = this.props.isEditable
		if (!isEditable) {
			$('[name=donationAmount]').attr('readOnly', true);
		}
		inputResize();
	},

	handleClick(eventName) {

	},

	handleKeyPress(event) {
		var allowedKeys = [16, 46, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57];
		if ($.inArray(event.charCode, allowedKeys) === -1) {
			addShake()
			return
		}
	},

	handleChange(event) {
		let val = event.target.value;
		val = val.replace(/[^0-9]/g, '') || 0;

		if (val.length > 9) {
			addShake();
			return;
		}

		inputResize();

		val = parseInt(val, 10).toString();

		if (val.length === 1) {
			val = `00${val}`;
		} else if (val.length === 2) {
			val = `0${val}`;
		}

		val = `${val.slice(0, -2)}.${val.slice(-2)}`;

		this.setState({ amount: val });
		this.props.handleAmount(val);
	},

	render() {
		const label = messages.amount.label;
		const placeholder = `0${this.props.decimalPoint}00`;
		const amount = `${this.state.amount}`.replace(
			/[.|,]/i,
			this.props.decimalPoint
		);

		return (
			<div className="col-xs-12 col-sm-12 col-md-12 amount_holder">
				<div className="inputField" >
					<div className="money_input">
						<div className="amount_currency">
							<span className="amount_currency_symbol" id="currencySymbol">{this.state.symbol}</span>
						</div>
						<label htmlFor="currencyAmount" className="sr-only">{label}</label>
						<input type="text"
							name="donationAmount"
							id="currencyAmount"
							placeholder={placeholder}
							pattern="[0-9]*"
							value={amount}
							onKeyPress={this.handleKeyPress}
							onChange={this.handleChange}
							onClick={this.handleClick.bind(this, 'donationAmountclick')}
							className="amount_number validate" />
							</div>
				</div>
				<p className="text-center" id="currencyCode">{this.state.code}</p>
			</div>
		);
	}
});



// WEBPACK FOOTER //
// ./common/amount.js